import * as type from '../../types/API/itemMappingType';
import { IAction } from '../userMetadataReducer';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getItemMappingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_ITEM_MAPPING:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ITEM_MAPPING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_ITEM_MAPPING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addItemMappingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_ITEM_MAPPING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_ITEM_MAPPING_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_ITEM_MAPPING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: null
      };
    default:
      return state;
  }
};

export const editItemMappingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_ITEM_MAPPING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_ITEM_MAPPING_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_ITEM_MAPPING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteItemMappingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_ITEM_MAPPING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_ITEM_MAPPING_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_ITEM_MAPPING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
